import React, { useState } from 'react';
import { Button, Dropdown, Menu, Modal } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { feedPostRequest } from '../../lib/feedPostApi';
import { MIN_ADMIN_YETKI } from '../../shared/variables/routes';
import { showNotification } from '../../shared/utils/notifications';

type Props = {
  event: LeagueFeed.Event;
  viewer?: Users.User;
  // eslint-disable-next-line no-unused-vars -- callback signature
  onRemoved: (id: string) => void;
};

/** Gönderi seçenekleri: yazan siler, diğerleri şikâyet eder, admin kaldırır. */
export default function FeedPostMenu({ event, viewer, onRemoved }: Props) {
  const { t } = useTranslation('leagues');
  const [reported, setReported] = useState(false);
  if (!viewer?.id) return null;
  const own = event.veri.oyuncu?.id === viewer.id;
  const admin = (viewer.yetki || 0) >= MIN_ADMIN_YETKI;

  const run = (action: 'delete' | 'remove' | 'report') =>
    Modal.confirm({
      title: t(`detail.posts.${action}Confirm`),
      okText: t(`detail.posts.${action}`),
      cancelText: t('detail.posts.cancel'),
      okButtonProps: { danger: action !== 'report' },
      onOk: async () => {
        try {
          if (action === 'report') {
            await feedPostRequest('POST', { postId: event.id, report: '1' });
            setReported(true);
            showNotification('success', t('detail.posts.reported'));
          } else {
            await feedPostRequest('DELETE', { postId: event.id });
            onRemoved(event.id);
            showNotification('success', t('detail.posts.removed'));
          }
        } catch {
          showNotification('error', t(action === 'report' ? 'detail.posts.reportError' : 'detail.posts.removeError'));
        }
      },
    });

  const items = [
    own && (
      <Menu.Item key="delete" danger onClick={() => run('delete')}>
        {t('detail.posts.delete')}
      </Menu.Item>
    ),
    !own && !reported && (
      <Menu.Item key="report" onClick={() => run('report')}>
        {t('detail.posts.report')}
      </Menu.Item>
    ),
    !own && admin && (
      <Menu.Item key="remove" danger onClick={() => run('remove')}>
        {t('detail.posts.remove')}
      </Menu.Item>
    ),
  ].filter(Boolean);
  if (!items.length) return null;
  return (
    <Dropdown overlay={<Menu>{items}</Menu>} trigger={['click']} placement="bottomRight">
      <Button
        type="text"
        className="feed-post__more"
        icon={<MoreOutlined aria-hidden="true" />}
        aria-label={t('detail.posts.options')}
        title={t('detail.posts.options')}
      />
    </Dropdown>
  );
}

FeedPostMenu.defaultProps = { viewer: undefined };
